import message from "@/utils/globalMessage";
import React, { useState } from 'react';
import UserDetailFormFields from '../components/UserDetailFormFields';
import { Card, Button, Typography, Form } from "antd";
import { RquestSignUp } from '@/redux/api';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useKeepAliveContext } from '@/hooks/use-keep-alive-context';
import { emitEvent, EventName } from '@/hooks/useEventBus';
import { CONTRACT_USER_ROLE, getCompanyFacilityIds } from '../utils';
import './index.css';

const { Title } = Typography;

export default function CreateUser() {
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const creatorCompany = useSelector(state => state.Facility?.selected?.record?.company_id);
    const creatorCompanyName = useSelector(state => state.Facility?.selected?.record?.company);
    const allFacilities = useSelector(state => state.Facility?.data || []);
    const { closeTab } = useKeepAliveContext();
    const [loading, setLoading] = useState(false);

    const goToDetailPage = (id) => {
        if (id) {
            navigate(`/admin/user-detail/${id}`);
        }
    }

    const createUser = () => {

        form.validateFields().then(({ id, avatar, company, user = [], companies = [], verify_password, ...values }) => {
            const isContractUser = values.role === CONTRACT_USER_ROLE;
            const facilityIds = isContractUser
                ? getCompanyFacilityIds(allFacilities, company)
                : user;

            if (isContractUser && facilityIds.length === 0) {
                message.error('No facilities are available for the selected company.');
                return;
            }
            const resultData = {
                company,
                ...values,
            }

            if (avatar) {
                resultData.image = avatar.originFileObj;
            }

            if (company?.value) {
                resultData.company = company.value;
            }

            resultData.user = facilityIds.join(',');
            resultData.companies = companies.join(',');
            setLoading(true);
            RquestSignUp(resultData).then(response => {
                if (response.status >= 200 && response.status < 300) {
                    closeTab();
                    emitEvent(EventName.USER_DETAIL_REFRESH);
                    goToDetailPage(response.data.id);
                    message.success('Create user successfully');
                }
            }).catch(error => {
                message.error('Create user failed');
            }).finally(() => {
                setLoading(false);
            });
        }).catch(error => {
            message.error('Form validation failed. Please ensure all inputs are correct and complete.');
        });
    }



    return (<Card
        className="create-user-container"
        title={<Title level={4}>Create User</Title>}
        extra={
            <Button loading={loading} type="primary" onClick={createUser}>Create</Button>
        }
    >
        <Form
            form={form}
            layout="vertical"
            className="detailForm create-user-form"
            initialValues={{
                role: 4,
                company: {
                    label: creatorCompanyName,
                    value: creatorCompany,
                },
                is_active: true,
            }}
                        autoComplete="off">
            <UserDetailFormFields disabled={false} isCreate={true} />
        </Form>
    </Card>
    )
}
